import { useEffect, useState } from 'react';
import * as reportApi from '../api/PomReport';
import { IPomReportCategoryData, IPomReportCategorySumItem, IPomReportDataCategoryPeriod, IPomReportDataInfo } from '../util/DataModelInterface'
import { Spinner } from './Spinner';
import { DateSelector } from './DateSelector';
import { getCurrentPeriodString, getStartOfYearPeriodString } from '../util/FormatDateUtil';
import useToastHandler from '../hooks/useToastHandler';
import { PomPeriodsList } from './PomPeriodsList';

export const ReportAdminPeriods = () => {
    const { addToast } = useToastHandler();

    const [categories, setCategories] = useState([] as IPomReportCategoryData[]);
    const [reportData, setReportData] = useState({} as IPomReportDataCategoryPeriod);
    const [reportInfoData, setReportInfoData] = useState({} as IPomReportDataInfo);
    const [reportCatSumData, setReportCatSumData] = useState({} as {[x: string]: IPomReportCategorySumItem});
    const [loading, setLoading] = useState(false);
    const [startPeriod, setStartPeriod] = useState(getStartOfYearPeriodString());
    const [endPeriod, setEndPeriod] = useState(getCurrentPeriodString());

    const [errorText, setErrorText] = useState("");

    useEffect(() => {
        setErrorText("");

        const fetchDataAsync = async () => {
            try {
                setLoading(true);
                const data1 = await reportApi.getReports(startPeriod, endPeriod, "", true);
                if (data1?.result) {
                    setReportData(data1.result.categories_period);
                    setReportInfoData(data1.result.info);
                    setReportCatSumData(data1.result.catSums);
                }
                else if (data1?.error) {
                    addToast(data1.error, 'reports', 'fetch');
                    setErrorText(data1.error.value);
                }

                if (!categories.length) {
                    const data2 = await reportApi.getCategories();
                    if (data2?.error) {
                        addToast(data2.error, 'reports', 'fetch');
                        setErrorText(data2.error.value);
                    } else if (data2) {
                      setCategories(data2);
                    }
                }
                setLoading(false);
            } catch (error) {
                return error;
            }
          }
        fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startPeriod, endPeriod]);


    return (
        <div id="tab-tabpane-lists" role="tabpanel" aria-labelledby="tab-tab-lists">
        <Spinner active={loading} />
        { !errorText &&
        <>
        <DateSelector
          startPeriod={startPeriod}
          endPeriod={endPeriod}
          isStartAndEnd={true}
          onChange={(start, end) => { setStartPeriod(start); setEndPeriod(end);}}
          showMonth={true}
          dateFormat='MM/yyyy'
          inputFormat='yyyy-MM'/>
          { categories && categories.length > 0 &&
              <PomPeriodsList
                categories={categories}
                reportPeriodData={reportData}
                reportInfoData={reportInfoData}
                reportCatSumData={reportCatSumData}
                period={startPeriod}
                companyName={""}
                periodEnd={endPeriod}
              />
          }

        </>
        }
        { errorText &&
            <div id="reportinfo">
                {errorText}
            </div> }
        </div>
    );
};